 /**
 * Bloquea la entrada de cualquier caracter que no sea letra (A–Z, a–z),
 * vocales acentuadas, 'ñ'/'Ñ' o espacios. Permite teclas de control.
 * @param {KeyboardEvent} e
 */
export function bloquearNoLetras(e) {
  const key = e.key;
  const esControl =
    key === 'Backspace' ||
    key === 'Delete'    ||
    key === 'ArrowLeft' ||
    key === 'ArrowRight'||
    key === 'Tab'       ||
    key === 'Enter';
  const regexLetra = /^[A-Za-zÁÉÍÓÚáéíóúÑñ ]$/;

  if (esControl) return; // dejamos pasar las teclas de control

  if (!regexLetra.test(key)) {
    e.preventDefault();
  }
}

/**
 * Elimina todo lo que no sea letra (A–Z, a–z), vocal acentuada, ñ/Ñ o espacio.
 * Previene que el usuario pegue texto con números o símbolos.
 * @param {string} texto
 * @returns {string} —
 *    texto limpio (solo letras y espacios)
 */
export function limpiarNoLetras(texto) {
  return texto.replace(/[^A-Za-zÁÉÍÓÚáéíóúÑñ ]+/g, '');
}

/**
 * Bloquea la entrada de cualquier caracter que no sea dígito (0–9).
 * Además, impide que el campo supere 10 caracteres.
 * Permite teclas de control (Backspace, Delete, flechas, Tab, Enter).
 *
 * @param {KeyboardEvent} e
 * @param {string} valorActual — valor actual del input (antes de que este evento modifique el contenido).
 *                                Esto se usa para determinar la longitud y evitar más de 10 dígitos.
 */
export function bloquearSoloNumerosCedula(e, valorActual) {
  const key = e.key;
  const esControl =
    key === 'Backspace' ||
    key === 'Delete'    ||
    key === 'ArrowLeft' ||
    key === 'ArrowRight'||
    key === 'Tab'       ||
    key === 'Enter';
  const esDigito = /^[0-9]$/.test(key);

  // Si es tecla de control, dejamos pasar (para borrar, moverse, etc.)
  if (esControl) return;

  // Si ya hay 10 dígitos y el usuario intenta escribir otro dígito, se bloquea.
  if (valorActual.length >= 10 && esDigito) {
    e.preventDefault();
    return;
  }

  // Si la tecla NO es un dígito, bloqueamos.
  if (!esDigito) {
    e.preventDefault();
  }
}

/**
 * Limpia un string dejando únicamente dígitos (0–9).
 * Luego, se asegura de devolver a lo sumo los primeros 10 dígitos resultantes.
 *
 * @param {string} texto
 * @returns {string} — cadena de hasta 10 dígitos numéricos
 */
export function limpiarSoloNumerosCedula(texto) {
  // Eliminamos todo lo que no sea dígito
  const soloDigitos = texto.replace(/[^0-9]+/g, '');
  // Devolvemos solamente los primeros 10 dígitos (si los hay)
  return soloDigitos.slice(0, 10);
}

/**
 * Bloquea la entrada de cualquier carácter que no sea dígito (0–9).
 * Además, impide que el campo supere 10 caracteres.
 * Permite teclas de control (Backspace, Delete, flechas, Tab, Enter).
 *
 * @param {KeyboardEvent} e
 * @param {string} valorActual — valor actual del input (antes de que este evento modifique el contenido).
 *                                Se usa para contar la longitud y evitar más de 10 dígitos.
 */
export function bloquearSoloNumerosMax10(e, valorActual) {
  const key = e.key;
  const esControl =
    key === 'Backspace' ||
    key === 'Delete'    ||
    key === 'ArrowLeft' ||
    key === 'ArrowRight'||
    key === 'Tab'       ||
    key === 'Enter';
  const esDigito = /^[0-9]$/.test(key);

  // Si es tecla de control (borrado, navegación, etc.), la dejamos pasar
  if (esControl) return;

  // Si ya hay 10 dígitos y el usuario intenta escribir otro dígito, lo bloqueamos
  if (valorActual.length >= 10 && esDigito) {
    e.preventDefault();
    return;
  }

  // Si la tecla no es un dígito, la bloqueamos
  if (!esDigito) {
    e.preventDefault();
  }
}

/**
 * Limpia un string dejando únicamente dígitos (0–9).
 * Luego, se asegura de devolver como máximo los primeros 10 dígitos.
 *
 * @param {string} texto
 * @returns {string} — cadena de hasta 10 dígitos numéricos
 */
export function limpiarSoloNumerosMax10(texto) {
  // Eliminamos todo lo que no sea dígito
  const soloDigitos = texto.replace(/[^0-9]+/g, '');
  // Devolvemos únicamente los primeros 10 dígitos (si los hay)
  return soloDigitos.slice(0, 10);
}